import React, { useEffect, useRef, useState } from 'react';
import { useViewlogies } from 'context';
import { hexToRGBA, capitalize } from 'utils';
import './mobileNavigation.scss';
import { FormattedMessage } from 'react-intl';
import m from './messages';
import Header from 'components/ClientHeader';

const MobileNavigation = ({ tabs, activeTab, onTabSelect, setTopbarHeight }) => {
    const {
        event: { color, firstName, lastName },
    } = useViewlogies();

    const selectedStyle = {
        backgroundColor: color,
        color: 'white',
    };

    const topbarRef = useRef(null);

    useEffect(() => {
        if (topbarRef.current) {
            setTopbarHeight(topbarRef.current.offsetHeight);
        }

        const handleResize = () => {
            if (topbarRef.current) {
                setTopbarHeight(topbarRef.current.offsetHeight);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="mobile-topbar" ref={topbarRef} style={{ ['--topbar-color']: hexToRGBA(color, 0.25) }}>
            <div className="menu">
                <div className="mobile-nav-container">
                    {/* <div> */}
                    <div className="mobile-tab-container">
                        <div className="nav-header">
                            <Header />
                            <h2>{`${capitalize(firstName)} ${capitalize(lastName)}`}</h2>
                        </div>

                        <div className="tab-layout">
                            {tabs.map(tab => (
                                <button
                                    key={tab}
                                    onClick={() => onTabSelect(tab)}
                                    className={`mobile-tab-button`}
                                    style={activeTab === tab ? selectedStyle : {}}
                                >
                                    <FormattedMessage {...m[tab]} />
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* </div> */}
                </div>
            </div>
        </div>
    );
};

export default MobileNavigation;
